import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { compact } from 'lodash-es';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { POSTAL_CODE_LABEL, STATE_PROVINCE_LABEL, socialIdFormat } from '@shared/constants/identity-formats';
import { Beneficiary } from '@shared/models';
import { toTitleCase } from '@shared/utils';

import { DateFormatPipe } from '../../../pipes/date-format.pipe';
import { PhonePipe } from '../../../pipes/phone.pipe';
import { DetailsItemComponent } from '../../details-item/details-item.component';

@Component({
  selector: 'app-beneficiary-review-modal',
  templateUrl: './beneficiary-review-modal.component.html',
  styleUrls: ['./beneficiary-review-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktButtonDirective, DetailsItemComponent, TitleCasePipe, PhonePipe, DateFormatPipe, RktIconComponent],
})
export class BeneficiaryReviewModalComponent {
  pageClassPrefix = 'beneficiary-review-';

  stateLabel = STATE_PROVINCE_LABEL;

  postalCodeLabel = POSTAL_CODE_LABEL;

  beneficiary!: Beneficiary | null;

  get beneficiaryGender() {
    return this.beneficiary?.sex === 'NONBINARY' ? 'Non-Binary' : toTitleCase(this.beneficiary?.sex);
  }

  /** A Canadian beneficial owner holds a SIN, not an SSN, so the label follows the issuing country. */
  get socialIdLabel(): string {
    return socialIdFormat(this.beneficiary?.socialIdCountryCode).label;
  }

  constructor(public activeModal: ActiveModal) {}

  modalInitData({ beneficiaryData }: { beneficiaryData: Beneficiary }) {
    this.beneficiary = {
      ...beneficiaryData,
      email: beneficiaryData?.primaryEmail?.value,
      phoneNumber: beneficiaryData?.primaryPhoneNumber?.number,
      placeOfBirthDisplayValue: compact([beneficiaryData?.placeOfBirth?.city, beneficiaryData?.placeOfBirth?.countryCode]).join(', '),
    };
  }
}
